import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/passport/Login'
import MerchantList from '@/pages/merchant/merchantList'
import Merchant from '@/pages/merchant/merchant'
import ForgetPwd from '@/pages/passport/ForgetPwd'
import Register from '@/pages/passport/Register'
import ResetPwdByEmail from '@/pages/passport/ResetPwdByEmail'
import ResetPwdByMobile from '@/pages/passport/ResetPwdByMobile'
import Home from '@/pages/home/Index'
import Layout from '@/components/Layout'
import LayoutSimple from '@/components/LayoutSimple'
import LayoutSideMenu from '@/components/LayoutSideMenu'
import PostSideMenu from '@/components/PostSideMenu'
import SelectShop from '@/pages/publish_task/SelectShop'
import Products from '@/pages/publish_task/product/Products'
import TaskCart from '@/pages/publish_task/cart/Products'
import Cart from '@/pages/publish_task/cart/Cart'
import Address from '@/pages/publish_task/address/Address'
import Condition from '@/pages/publish_task/condition/Condition'
import Payment from '@/pages/publish_task/payment/Payment'
import Confirm from '@/pages/publish_task/Confirm'
import PublishTask from '@/pages/publish_task/Index'
import OrderList from '@/pages/orders/list/List'
import MailList from '@/pages/orders/mail/list'
import CartList from '@/pages/orders/cart/list'
import ExpressMonitor from '@/pages/orders/express_monitor/list'
import CardList from '@/pages/orders/card/list'
import ExpressBill from '@/pages/orders/express_bill/list'
import Ticketlist from '@/pages/orders/ticket/List'
import Monitorlist from '@/pages/orders/monitor/list'
import MerchantOrderList from '@/pages/merchantOrders/list/List'
import Dashboard from '@/pages/single_user_center/Dashboard'
import IncomeDetail from '@/pages/single_user_center/IncomeDetail'
import GetWithdraw from '@/pages/single_user_center/GetWithdraw'
import Profile from '@/pages/user_center/Profile'
import Logout from '@/pages/passport/Logout'
import AddressList from '@/pages/user_center/AddressList'
import Messages from '@/pages/user_center/Messages'
import Wechat from '@/pages/payment/Wechat'
import OrderShare from '@/pages/orders/share/Order'
import Complete from '@/pages/publish_task/Complete'
import Snatched from '@/pages/orders/snatch/snatch'
import Privacy from '@/pages/privacy/privacy'
import QrCode from '@/pages/qrcode/qrcode'
import AppRedirect from '@/pages/qrCode/appredirect'
import AppShortUrl from '@/pages/qrCode/appshorturl'
import Frame from '@/pages/frame/index'
import TrackCode from '@/pages/qrcode/trackCode'
import SearchCode from '@/pages/qrcode/searchCode'
import ProductCode from '@/pages/qrcode/productCode'
import HelpCenter from '@/pages/HelpCenter/HelpCenter'
import Law from '@/pages/Law/Law'
import Company from '@/pages/company/company'
import Goods from '@/pages/goods/Goods'
import GoodsList from '@/pages/goods/GoodsList'
import NormalProduct from '@/pages/goods/product'
import Good from '@/pages/goods/GoodsDetail'
import Tracktask from '@/pages/tracktask/Tracktask'
import PrivateAgreement from '@/pages/treaty/PrivateAgreement'
import UserAgreement from '@/pages/treaty/UserAgreement'
import AmountBill from '@/pages/orders/amount_bill/List2'
import ArticleList from '@/pages/articles/List'
import Crawler from '@/pages/articles/Crawler'
import ArticleDetail from '@/pages/articles/Detail'
import ProductDetail from '@/pages/products/Detail'
import MyArticle from '@/pages/articles/Mypost'
import ArticlePublish from '@/pages/articles/Publish'
import Tongji from '@/pages/articles/Tongji'

import taskpay from '@/pages/home/taskpay'
import malipay from '@/pages/home/alipay'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    //{
    //  path: '*', redirect: '/index',
    //},
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/taskpay',
      name: 'taskpay',
      component: taskpay,
      meta: {
        title: '任务支付'
      }
    },
    {
      path: '/mapay/:id',
      name: 'mapay',
      component: malipay,
      meta: {
        title: '支付宝支付'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/MerchantList',
      name: 'MerchantList',
      component: MerchantList,
      meta: {
        title: '商家列表'
      }
    }, {
      path: '/Merchant/:id',
      name: 'Merchant',
      component: Merchant,
      meta: {
        title: '商品列表'
      }
    }, {
      path: '/products/:id',
      name: 'Goods',
      component: Goods,
      meta: {
        title: '商品列表'
      }
    }, {
      path: '/products/list/:id',
      name: 'GoodsList',
      component: GoodsList,
      meta: {
        title: '商品列表'
      }
    }, {
      path: '/items/:id',
      name: 'NormalProduct',
      component: NormalProduct,
      meta: {
        title: '商品列表'
      }
    }, {
      path: '/item/:id',
      name: 'Item',
      component: Good,
      meta: {
        title: '商品详情'
      }
    }, {
      path: '/HelpCenter',
      name: 'HelpCenter',
      component: HelpCenter,
      meta: {
        title: '常见问题'
      }
    }, {
      path: '/Company',
      name: 'Company',
      component: Company,
      meta: {
        title: '公司'
      }
    }, {
      path: '/Law',
      name: 'Law',
      component: Law,
      meta: {
        title: '法律条款'
      }
    },{
      path: '/product',
      name: 'ProductDetail',
      component: ProductDetail,
      meta: {
          title: '商品详情'
        }
    }, {
      path: '/TaskMarket',
      name: 'Snatched',
      component: Snatched,
      meta: {
        title: '任务市场'
      }
    }, {
      path: '/Privacy',
      name: 'privacy',
      component: Privacy,
      meta: {
        title: '隐私政策'
      }
    },{
      path: '/qrCode',
      name: 'qrCode',
      component: QrCode,
      meta: {
        title: '二维码'
      }
    },{
      path: '/appredirect',
      name: 'appredirect',
      component: AppRedirect,
      meta: {
        title: '跳转'
      }
    },{
      path: '/appshorturl',
      name: 'appshorturl',
      component: AppShortUrl,
      meta: {
        title: 'joyorders'
      }
    }, {
      path: '/track/:id',
      name: 'trackCode',
      component: TrackCode,
      meta: {
        title: '物流二维码'
      }
    }, {
      path: '/search',
      name: 'searchCode',
      component: SearchCode,
      meta: {
        title: '搜索二维码'
      }
    }, {
      path: '/product/:id',
      name: 'productCode',
      component: ProductCode,
      meta: {
        title: '商品二维码'
      }
    }, {
      path: '/Complete',
      name: 'Complete',
      component: Complete,
      meta: {
        title: '发布完成'
      }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
      meta: {
        title: '退出'
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        title: '注册'
      }
    },
    {
      path: '/forget_pwd',
      name: 'ForgetPwd',
      component: ForgetPwd,
      meta: {
        title: '忘记密码'
      }
    },
    {
      path: '/reset_password',
      name: 'ResetPwdByEmail',
      component: ResetPwdByEmail,
      meta: {
        title: '重置密码'
      }
    },
    {
      path: '/reset_password_by_mobile',
      name: 'ResetPwdByMobile',
      component: ResetPwdByMobile,
      meta: {
        title: '重置密码'
      }
    },
    {
      path: '/user-agreement',
      name: 'user-agreement',
      component: UserAgreement,
      meta: {
        title: '个人协议'
      }
    },
    {
      path: '/private-agreement',
      name: 'private-agreement',
      component: PrivateAgreement,
      meta: {
        title: '隐私协议'
      }
    },
    {
      path: '/',
      name: 'Main',
      component: Layout,
      children: [{
        path: 'cart',
        name: 'cart',
        component: Cart,
        meta: {
          title: '购物车'
        }
      }, {
        path: 'messages',
        name: 'messages',
        component: Messages,
        meta: {
          title: '消息列表'
        }
      }, {
        path: 'tracktask',
        name: 'tracktask',
        component: Tracktask,
        meta: {
          title: '跟踪任务'
        }
      }]
    },
    {
      path: '/publish_task',
      name: 'Main',
      component: Layout,
      children: [{
        path: 'shop',
        name: 'shop',
        component: SelectShop,
        meta: {
          title: '发布任务-选择商家'
        }
      }]
    },
    {
      path: '/payment',
      name: 'Payment',
      component: LayoutSimple,
      children: [{
        path: 'wechat',
        name: 'wechat',
        component: Wechat,
        meta: {
          title: '微信支付'
        }
      }]
    },
    {
      path: '/',
      name: 'Payment',
      component: LayoutSimple,
      children: [{
        path: 'customer/publish_task/shop',
        name: 'publish_task/shop',
        component: SelectShop,
        meta: {
          title: '个人中心-选择商家'
        }
      }, {
        path: 'customer/publish_task/products',
        name: 'publish_task/products',
        component: Products,
        meta: {
          title: '个人中心-商品信息'
        }
      }, {
        path: 'customer/publish_task/cart',
        name: 'publish_task/cart',
        component: Cart,
        meta: {
          title: '发布任务-购物车'
        }
      },{
        path: 'customer/publish_task/address',
        name: 'publish_task/address',
        component: Address,
        meta: {
          title: '个人中心-收货地址'
        }
      }, {
        path: 'customer/publish_task/condition',
        name: 'publish_task/condition',
        component: Condition,
        meta: {
          title: '个人中心-下单条件'
        }
      }, {
        path: 'customer/publish_task/payment',
        name: 'publish_task/payment',
        component: Payment,
        meta: {
          title: '个人中心-支付方式'
        }
      }, {
        path: 'customer/publish_task/confirm',
        name: 'publish_task/confirm',
        component: Confirm,
        meta: {
          title: '个人中心-确认'
        }
      }, {
        path: 'buyer/publish_task/shop',
        name: 'publish_task/shop',
        component: SelectShop,
        meta: {
          title: '个人中心-选择商家'
        }
      }, {
        path: 'buyer/publish_task/products',
        name: 'publish_task/products',
        component: Products,
        meta: {
          title: '个人中心-商品信息'
        }
      }, {
        path: 'buyer/publish_task/cart',
        name: 'publish_task/cart',
        component: Products,
        meta: {
          title: '发布任务-购物车'
        }
      }, {
        path: 'buyer/publish_task/address',
        name: 'publish_task/address',
        component: Address,
        meta: {
          title: '个人中心-收货地址'
        }
      }, {
        path: 'buyer/publish_task/condition',
        name: 'publish_task/condition',
        component: Condition,
        meta: {
          title: '个人中心-下单条件'
        }
      }, {
        path: 'buyer/publish_task/payment',
        name: 'publish_task/payment',
        component: Payment,
        meta: {
          title: '个人中心-支付方式'
        }
      }, {
        path: 'buyer/publish_task/confirm',
        name: 'publish_task/confirm',
        component: Confirm,
        meta: {
          title: '个人中心-确认'
        }
      }, {
        path: 'order/share',
        name: 'order/share',
        component: OrderShare,
        meta: {
          title: '订单'
        }
      }]
    },
    {
      path: '/publish_task',
      name: 'PublishTask',
      component: LayoutSimple,
      children: [{
        path: 'products',
        name: 'products',
        component: Products,
        meta: {
          title: '发布任务-商品信息'
        }
      }, {
        path: 'cart',
        name: 'cart',
        component: TaskCart,
        meta: {
          title: '发布任务-购物车'
        }
      }, {
        path: 'address',
        name: 'address',
        component: Address,
        meta: {
          title: '发布任务-收货地址'
        }
      }, {
        path: 'condition',
        name: 'condition',
        component: Condition,
        meta: {
          title: '发布任务-下单条件'
        }
      }, {
        path: 'payment',
        name: 'payment',
        component: Payment,
        meta: {
          title: '发布任务-支付方式'
        }
      }, {
        path: 'confirm',
        name: 'confirm',
        component: Confirm,
        meta: {
          title: '发布任务-支付方式'
        }
      }]
    },
    {
      path: '/customer',
      name: 'UserCenter',
      component: LayoutSideMenu,
      children: [{
        path: 'task/list',
        name: 'task/list',
        component: OrderList,
        meta: {
          title: '个人中心-我的任务'
        }
      }, {
        path: 'profile',
        name: 'profile',
        component: Profile,
        meta: {
          title: '个人中心-账户信息'
        }
      }, {
        path: 'address/list',
        name: 'address/list',
        component: AddressList,
        meta: {
          title: '个人中心-收货地址'
        }
      }]
    },
    {
      path:'/',
      component:PostSideMenu,
      children:[
        {
          path: '/explore',
          name: 'explore',
          component: ArticleList,
          meta: {
            title: '发现'
          }
        },
        {
          path: '/assistant',
          name: 'crawler',
          component: Crawler,
          meta: {
            title: '助手'
          }
        },
        {
          path: '/explore/post',
          name: 'explore/post',
          component: ArticleDetail,
          meta: {
            title: '笔记详情'
          }
        },
        {
          path: '/mypost',
          name: 'mypost',
          component: MyArticle,
          meta: {
            title: '我的笔记'
          }
        },
        {
          path: '/publish',
          name: 'publish',
          component: ArticlePublish,
          meta: {
            title: '发布'
          }
        },
        {
          path: '/tongji',
          name: 'tongji',
          component: Tongji,
          meta: {
            title: '统计'
          }
        },
      ]
    },
    {
      path: '/buyer',
      name: 'SingleUserCenter',
      component: LayoutSideMenu,
      children: [{
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
          title: '个人中心-概览'
        }
      }, {
        path: 'income',
        name: 'income',
        component: IncomeDetail,
        meta: {
          title: '个人中心-收支明细'
        }
      }, {
        path: 'withdraw',
        name: 'withdraw',
        component: GetWithdraw,
        meta: {
          title: '个人中心-提现方式'
        }
      },
        {
          path: 'publish_task/index',
          name: 'publish_task/index',
          component: PublishTask,
          meta: {
            title: '个人中心-发布任务'
          }
        },
        {
          path: 'merchantOrder/list',
          name: 'merchantOrder/list',
          component: MerchantOrderList,
          meta: {
            title: '个人中心-商家订单'
          }
        }, {
          path: 'task/maillist',
          name: 'task/maillist',
          component: MailList,
          meta: {
            title: '个人中心-邮件列表'
          }
        }, {
          path: 'task/cardlist',
          name: 'task/cardlist',
          component: CardList,
          meta: {
            title: '个人中心-礼卡列表'
          }
        }, {
          path: 'task/express_bill',
          name: 'task/express_bill',
          component: ExpressBill,
          meta: {
            title: '个人中心-物流账单'
          }
        },
        {
          path: 'task/amount_bill',
          name: 'task/amount_bill',
          component: AmountBill,
          meta: {
            title: '个人中心-费用账单'
          }
        }
        , {
          path: 'task/cartlist',
          name: 'task/cartlist',
          component: CartList,
          meta: {
            title: '个人中心-待买清单'
          }
        },
        {
          path: 'task/express_monitor',
          name: 'task/express_monitor',
          component: ExpressMonitor,
          meta: {
            title: '个人中心-物流监控'
          }
        },
        {
          path: 'task/ticketlist',
          name: 'task/ticketlist',
          component: Ticketlist,
          meta: {
            title: '个人中心-工单列表'
          }
        },
        {
          path: 'task/monitorlist',
          name: 'task/monitorlist',
          component: Monitorlist,
          meta: {
            title: '个人中心-监控列表'
          }
        },
        {
          path: 'task/list',
          name: 'task/list',
          component: OrderList,
          meta: {
            title: '个人中心-我的任务'
          }
        }]
    }
  ]
})

let $ = require('jQuery')
router.afterEach(function (to, from, next) {
  document.title = 'JoyOrders-' + to.meta.title
  $(document).scrollTop(0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js